import { HomeQuestionSelectContent } from './HomeQuestionSelectContent';
export default HomeQuestionSelectContent;